var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.77 7.99C4.97 8.19 4.97 8.5 4.77 8.7C4.58 8.9 4.26 8.9 4.06 8.7L0.15 4.78C-0.05 4.59 -0.05 4.27 0.15 4.07L4.07 0.15C4.27 -0.05 4.58 -0.05 4.78 0.15C4.98 0.35 4.98 0.66 4.78 0.86L1.21 4.43L4.77 7.99Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.7e2e22c8a066905a69dd2f83c4c99a27.svg";
export { ForwardRef as ReactComponent };